import { render, staticRenderFns } from "./old-versions.vue?vue&type=template&id=5a074e72&scoped=true"
import script from "./old-versions.vue?vue&type=script&lang=js"
export * from "./old-versions.vue?vue&type=script&lang=js"
import style0 from "./old-versions.vue?vue&type=style&index=0&id=5a074e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a074e72",
  null
  
)

export default component.exports